<template>
    <v-dialog
      v-model="display"
      width="450"
    >
      <v-card
        color="white"
      >
        <v-card-text
            style="text-align: center;"
        >
            <v-icon
                size="64"
                color="#3F51B5"
                style="margin-bottom: 15px;"
            >
                mdi-gift-open
            </v-icon>
            <h2>Please update your bookmarks</h2>
            <div
                style="font-size: 16px;"
            >
                {{ app_name }} has moved to a new domain. You were automatically redirected.<br /><br />
                The new address is:
            </div>
            <div
                style="font-family: monospace;padding: 5px;background: rgba(0,0,0,0.1);"
            >
                {{ getHostname() }}
            </div>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                @click="display = false"
                color="primary"
            >
                OK
            </v-btn>
            <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex'
  
  export default {
    data () {
      return {
        display: true
      }
    },
    created () {
    },
    methods: {
        getHostname() {
            return window.location.host
        }
    }
  }
  </script>
  